/**
 * A full-height screen for the capture flow, replacing ion-page/ion-content.
 *
 * What those two were actually providing here, now that the app is
 * browser-only: a full-viewport box, an internal scroll container, and
 * safe-area padding so a notch does not eat the first control. All three are
 * a handful of CSS, and none of them needed a component library.
 *
 * `bare` drops the padding and the ground for the camera screens, which paint
 * edge to edge over live video.
 */
export const CaptureScreen: React.FC<{
  children: React.ReactNode;
  bare?: boolean;
  className?: string;
  testId?: string;
}> = ({ children, bare, className = '', testId }) => (
  <main
    data-testid={testId}
    className={`flex min-h-0 flex-1 flex-col overflow-y-auto ${
      bare ? 'bg-black' : 'bg-background font-sans text-foreground'
    } ${className}`}
    style={{
      paddingTop: bare ? undefined : 'env(safe-area-inset-top)',
      paddingBottom: 'env(safe-area-inset-bottom)',
    }}
  >
    {children}
  </main>
);
